<template>
<div class="container-fluid">
	<contact-toolbar heading="Supplier Purchases" :heading="false"></contact-toolbar>

	<collapsible-panel :always-open="true">
		<template slot="panel">
			<panel-menu
				:menu-items="tabs"
				:active-item="activeTab"
				v-on:itemClick="menuChange"
			></panel-menu>
		</template>

		<template slot="main">

			<!-- Purchase Order Tab -->
			<template v-if="activeTab == 'Purchase Orders'">
				<table-list record-name="Purchase Order"
					:fields="purchaseOrderFields"
					:records="mutatedPurchaseOrders"
					:has-edit="true"
					v-on:edit="editPurchaseOrder">

					<h2>
						Purchase Orders <br>
						<small>{{$store.contact.name}}</small>
					</h2>

				</table-list>
			</template>

			<!-- Expenses Tab -->
			<expense-table
				v-else
				heading="Expenses"
				:heading-small="$store.contact.name"
				:show-job="true"
				:show-user="true"
				:editable="true"
				:filters="[
					['supplier_id', $store.contact.id]
				]"
				:filtering-tools="true">
			</expense-table>

			<image-viewer
				v-if="receiptImageUrl"
				v-on:close="receiptImageUrl=false"
				:url="receiptImageUrl">
			</image-viewer>

		</template>
	</collapsible-panel>

</div>
</template>
<script type="text/javascript">
import ContactToolbar from "./ContactToolbar"
import ContactMixins from "@/mixins/ContactMixins"
import PanelMenu from "@/components/PanelMenu"
import ExpenseEditModal from "@/components/super_components/ExpenseEditModal"

import CollapsiblePanel from "../../layout_fragments/CollapsiblePanel"
import ImageViewer from "@/components/ImageViewer"

import TableList from "@/components/TableList"
import ExpenseTable from "@/components/super_components/ExpenseTable"

export default {
	name: "SupplierContactPurchases",
	components: {
		ContactToolbar,
		TableList,
		CollapsiblePanel,
		ImageViewer,
		PanelMenu,
		ExpenseEditModal,
		ExpenseTable
	},
	mixins:[ContactMixins],
	data() {
		return {
			activeTab: "Purchase Orders",

			purchaseOrders: [],
			purchaseOrderFields: [
				{label: "PO #",key:'fullPONum'},
				{label: "Project/Service",key: "jobNum"},
				{label: "PO Date",key:'poDate'},
				{label: "Subject",key:'subject'},
				{label: "Last Emailed",key:"lastEmailed"},
				{label: "Status",key:'status'}
			],

			expenses: [],
			expenseFields: [
				{label: "#",key:"projectNum"},
				{label: "Project/Service",key: "projectName"},
				{label: "Expense Group",key: "expenseGroupName"},
				{label: "Code",key: "expenseCodeName"},
				{label: "Purchase Date",key: "purchase_date"},
				{label: "Cost",key: "totalCost",align: "right"},
				{label: "Description",key: "description"},
				{label: "Payment Method",key: "payment_method"},
				{label: "Reviewed By",key: "reviewedByName"},
				{label: "Approved",key: "approvedIcon"},
				{label: "Denied Reason",key: "shortDeniedReason"}
			],

			editModal: {
				visible: false,
				record: []
			},

			receiptImageUrl: "",

			tabs: [
				'Purchase Orders',
				'Expenses'
			]
		}
	},
	computed: {

		mutatedPurchaseOrders() {
			// Populate this.purchaseOrders with the correct table values

			let vm = this

			return this.purchaseOrders.map(po => {

				po.jobNum = ""
				if ("Job" in po && po.Job) {
					po.fullPONum = po.Job.job_num+"-"+po.po_num
					po.jobNum = "Project #"+po.Job.job_num
				}
				else if ("Service" in po && po.Service) {
					po.fullPONum = po.Service.job_num+"-"+po.po_num
					po.jobNum = "Service #"+po.Service.job_num
				}
				
				po.poDate = vm.formatDateTimeToLocal(po.po_date, "full-date")
				po.lastEmailed = vm.formatDateTimeToLocal(po.last_emailed, "full-date")

				return po
			})
		},

		mutatedExpenses() {
			// Populate this.expenses with the correct table values

			let vm = this
			return this.expenses.map(exp => {

				exp.projectNum = exp.Job.job_num;
				exp.projectName = exp.Job.job_name;
				exp.expenseGroupName = exp.ExpenseGroup.group_name;
				exp.expenseCodeName = exp.ExpenseCode.code;
				exp.totalCost = (+exp.cost + +exp.tax + +exp.tip).toFixed(2);

				//services.trade-traks.ca/resources/receipt-images/{sessionToken}/{filename}
				exp.receiptImageLink = window.apiRoot+"/resources/receipt-images/"+vm.$store.sessionToken+"/"+exp.ReceiptImage.filename

				return exp

			})
		}

	},
	methods: {

		menuChange(item) {
			// Change url based on tab (purchase order OR expense)
			this.activeTab = item
			window.history.pushState({}, "", "/contact/" + this.$route.params.id + "/purchases/" + this.activeTab.slugify())

			// NEW
			if (this.activeTab === 'Purchase Orders') {
				//fetch purchase orders
				this.fetchPurchaseOrders()
			}
			else if (this.activeTab === 'Expenses') {
				//fetch expenses
				this.fetchExpenses()
			}
		},

		editPurchaseOrder(po) {
			// Change tab to edit purchase ordr
			this.$router.push("/project/" + po.Job.slug + "/purchase-orders/" + po.slug)
		},

		editExpense(record) {

			let promises = [
				this.fetchUsers([],false,["first_name","last_name","email"]),
				this.fetchModel('ExpenseGroup')
			]

			this.spinner(true)

			let vm = this

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (record.reviewed_by == 0)
					record.approved = null

				vm.editModal.visible = true
				vm.editModal.record = record

			})
		},

		closeEditModal() {
			this.editModal.visible = false
		},

		openReceiptMenu(expense) {
			this.receiptImageUrl = expense.receiptImageLink
		},

		fetchPurchaseOrders() {
			// Fetch purchase orders and update this.purchaseOrders

			let vm = this

			let params = {
				filters: [
					["supplier_id", this.$store.contact.id],
					["is_finalized", true]
				],
				include: [
					{
						model: "Job",
						fields: ["id", "slug", "job_num", "job_name"]
					},
					{
						model: "Service",
						fields: ["id", "slug", "job_num", "job_name"]
					}
				]
			}

			this.getJSON("PurchaseOrder/get", params).then(response => {
				if (response.success) {
					vm.purchaseOrders = response.data
				}
			})
		},

		fetchReceipt() {
			// Fetch the receipt and image
		},

		fetchExpenses() {
			// Fetch expenses and update this.expenses

			let vm = this

			let params = {
				filters: [
					["supplier_contact_id", this.$store.contact.id]
				],
				include: [
					{
						model: "Job",
						fields: ["id", "slug", "job_num", "job_name"]
					},
					{
						model: "Service",
						fields: ["id","slug","job_num","job_name"]
					},
					"User",
					"ExpenseCode",
					"ExpenseGroup",
					"ReceiptImage"
				]
			}

			this.getJSON("Expense/get", params).then(response => {
				if (response.success) {
					vm.expenses = response.data
				}
			})
		}
	},

	created() {

		let vm = this

		this.fetchContact(this.$route.params.id, [{model:"ContactFile", fields:[]}]).then(response => {
			if (this.activeTab === 'Purchase Orders') {
				//fetch purchase orders
				this.fetchPurchaseOrders()
			}
			else if (this.activeTab === 'Expenses') {
				//fetch expenses
				this.fetchExpenses()
			}
		})

		let slug = this.activeTab.slugify()

		this.tabs.forEach(tab => {
			if (tab.slugify() === vm.$route.params.tab)
				vm.activeTab = tab
		})


	}
}
</script>